import qs from 'qs'
import snakecaseKeys from 'snakecase-keys'

import type { ReplacementDataActionURL } from '@shared/api/rtkQuery/contentTemplate'
import checkHasUtmProperties from '@shared/lib/utils/checkHasUtmProperties'
import deleteEmptyKeys from '@shared/lib/utils/deleteEmptyKeys'
import splitUrl from '@shared/lib/utils/splitUrl'

const mapPreviewUrlWithUtm = (
  urlParams: ReplacementDataActionURL['urlParams']
) => {
  const { host, ...utmObj } = urlParams
  if (!host) {
    return ''
  }

  if (checkHasUtmProperties(host)) {
    return host
  }

  // `#fragment`（錨點）是網址結構的一部分，必須先剝離、組完 query 後接回結尾，
  // 否則會組出 `...#fragment?utm=...`（query 落入 fragment，UTM 與錨點雙雙失效）。
  const { origin, query, hash } = splitUrl(host)
  const queryStringObj = {
    ...qs.parse(query),
    ...deleteEmptyKeys(snakecaseKeys(utmObj)),
  }
  const queryString = qs.stringify(queryStringObj)

  return [origin, queryString].filter(Boolean).join('?') + hash
}

export default mapPreviewUrlWithUtm
